import { ToastContainer } from 'react-toastify';

export const ToastProvider: React.FC = () => (
  <ToastContainer
    position="top-center"
    autoClose={5000}
    hideProgressBar={true}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    closeButton={false}
  />
);
